import React from "react";
import {
  DISPATCH_ROUTE_PILL_RADIUS_CLASS_NAME,
  emptyToneClasses,
  joinClasses,
  pillToneClasses,
  statusToneClasses,
} from "./shared.js";

export function StatusBadge({ tone = "neutral", className = "", children, ...props }) {
  return (
    <span
      data-status-badge="true"
      className={joinClasses([
        `inline-flex items-center justify-center px-2.25 py-1.25 text-[0.68rem] font-extrabold uppercase tracking-[0.04em] whitespace-nowrap ${DISPATCH_ROUTE_PILL_RADIUS_CLASS_NAME}`,
        statusToneClasses[tone] || statusToneClasses.neutral,
        className,
      ])}
      {...props}
    >
      {children}
    </span>
  );
}

export function Pill({ tone = "info", className = "", children, ...props }) {
  return (
    <span
      className={joinClasses([
        `pill inline-flex items-center justify-center gap-2 px-2.5 py-1.5 text-[0.74rem] font-extrabold tracking-[0.01em] whitespace-nowrap ${DISPATCH_ROUTE_PILL_RADIUS_CLASS_NAME}`,
        pillToneClasses[tone] || pillToneClasses.info,
        className,
      ])}
      {...props}
    >
      {children}
    </span>
  );
}

export function EmptyState({
  children = null,
  className = "",
  message = "",
  messageClassName = "",
  title = "",
  titleClassName = "",
  tone = "default",
  ...props
}) {
  return (
    <div
      className={joinClasses([
        "grid gap-2 rounded-[8px] border px-4 py-4",
        emptyToneClasses[tone] || emptyToneClasses.default,
        className,
      ])}
      {...props}
    >
      {title ? (
        <h3
          className={joinClasses([
            "font-display text-[1.02rem] font-semibold leading-[1.08] tracking-[-0.03em] text-text",
            titleClassName,
          ])}
        >
          {title}
        </h3>
      ) : null}
      {message ? (
        <p
          className={joinClasses([
            "text-sm leading-7 text-muted",
            messageClassName,
          ])}
        >
          {message}
        </p>
      ) : null}
      {children}
    </div>
  );
}
